<template>

  <!--          Миний сан-->
  <div class="w-full sm:w-1/1 md:w-3/5 lg:w-3/5 px-2 mb-3 flex flex-col">
    <div class="p-6 bg-[#121212] rounded-lg w-full shadow-2xl bg-base-100 lg:text-left">
      <header class="rounded-t-lg font-bold text-1xl pb-4 px-6 border-b-[1px] border-gray-500">
        <i class="uil uil-database-alt"></i>
        Миний сан
      </header>
      <div class="series-container">
        <div class="divider mt-0 after:bg-gray-500 before:bg-gray-500 mb-5" ></div>
        <div class="relative z-10">
          <div class="media-list">
            <!--      <div v-if="page == 1 && isLoadingPage" class="media-loader-wrap">-->
            <!--        <ProgressSpinner/>-->
            <!--      </div>-->

            <div  class="media-grid-wrapper" >
              <div class="seeroo-grid grid gap-4 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-2 cs-style-4" >
                <div v-for="item in likedMediaList" :key="item.id" class="liked-item" >
                    <router-link :to="`/theatre/detail/${item.id}`" class="liked-cover">
                      <a href="javascript:void(0)" class="card__play">
                        <i class="isax isax-play"></i>
                      </a>
                    </router-link>

                    <img :src="Poster" v-lazy:background-image="imageUrl(item.image, true)" class="poster rounded-md"/>
                    <div class="liked-item-info">
                      <router-link to="/detail" class="line-clamp-1">{{ item.title }}</router-link>
                    </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="hasMore && !isLoadingPage" class="pagination">
            <ProgressSpinner v-if="isLoadingMore" style="width:50px;height:50px" strokeWidth="3" animationDuration="1s"/>
            <Button v-else type="button" @click="getEpisodes">
              <span>Цааш</span>
              <i class="pi pi-angle-double-down"></i>
            </Button>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>

// import Loader from "../../components/loader.vue";
// import MyFundPlaceholder from "../../components/placeholders/my-fund-placeholder.vue";
// import {mapActions} from "vuex";
// import { mapGetters } from "vuex/dist/vuex.cjs.js";
// import axios from "axios";
import Poster from "../../assets/poster.png";
import api from '../../store/_boot/baseApi';
import {imageUrl} from "@utils";
import {setModalActive} from "@store";

export default {
  name: 'MyLiked',
  props: ["url", "hlink"],
  components: {
    // Loader,
    // MyFundPlaceholder,
  },
  data() {
    return {
      perPage: 100,
      isLoading: false,
      contents: [],
      isLoadingPage: true,
      isLoadingMore: false,
      // cat: null,
      hasMore: false,
      page: 1,
      Poster
    };
  },

  computed: {
    likedMediaList() {
      console.log("dcsdcdscsd------->");
      console.log("front media list", this.$store.state['likedMediaList']);
      return this.$store.state['likedMediaList'];
    }
  },

  created() {
    this.getEpisodes();
  },

  methods: {
    imageUrl,
    handleClick(animeID) {
      this.$router.replace({query: {media: animeID}});
      setModalActive(true);
    },
    getEpisodes() {
      this.isLoadingMore = true;
      this.$store.dispatch('getLikedMedia', {vm: this});
    },
    // ...mapActions(["setEpisode", "gotoTheatre", "getEpisodes", "getAnime", "setBackLink"]),



    async getLikedContents() {
      if (this.isLoading || !this.hasMore) return;
      this.isLoading = true;
      try {
        const response = await api.get("/api/profile/my-fund/" + this.user.id, {
          params: {
            page: this.page,
            perPage: this.perPage,
          },
        });

        const { data } = response;
        if (data.data.length > 0) {
          this.contents.push(...data.data);
          this.page++;
        } else {
          this.hasMore = false;
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.isLoading = false;
      }
    },

    gotoWatch(animeId, epId) {
      console.log('epId',epId)
      this.setBackLink(this.$route.path);
      this.$router.push(`/theatre/detail/${animeId}`);
    },
    handleScroll() {
      const scrollTop = window.scrollY;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (scrollTop + clientHeight >= scrollHeight - 500) {
        this.getLikedContents();
      }
    },
  },
  mounted() {
    this.getLikedContents();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
